import { AuthEnums } from "models/enums";
import { useSelector } from "react-redux";
import { CompanyService } from "services";
import { AppState } from "store";
import { WintSuperkollAPIModel as ApiModels } from "wint-api-client/dist/types";

function useReadOnlyState(state?: ApiModels.ReceiptStateApiModel, createdById?: number) {
  const currentUser = useSelector((store: AppState) => store.auth.loggedInUser.personId);
  const isReceiptAdmin = CompanyService.hasRelation(AuthEnums.PersonCompanyRelationType.ReceiptsAdmin);

  switch (state) {
    case ApiModels.ReceiptStateApiModel.WaitingAcceptance:
      return !isReceiptAdmin;
    case ApiModels.ReceiptStateApiModel.Draft:
    case ApiModels.ReceiptStateApiModel.SentBackToCustomer:
    case ApiModels.ReceiptStateApiModel.SentBackFromReceiptAdmin:
      return currentUser !== createdById && !isReceiptAdmin;
    default:
      return true;
  }
}

export default useReadOnlyState;
